import React, { Component } from 'react';
import * as esriLoader from 'esri-loader';
import FilterListComponent from './FilterListComponent'
import ResultsStore from '../store/ResultsStore';
import ResultsComponent from "./ResultsComponent";
import '../App.css';

export default class BuildingsFilterComponent extends Component {

  constructor() {
    super();
    this.resultsStore = new ResultsStore();
    this.state = {
      resultsCount: 0,
      tabSelected: 'search',
      whereClause: ""
    }
  }

  tabChanged(tabSelected) {
    if (tabSelected === 'results') {
      //this.startUpdatingResults();
    }
    this.setState({ tabSelected: tabSelected });
  }

  renderFilters() {
    const isVisible = {display: (this.state.tabSelected==="search" ? "block" : "none")};
    return (
      <div style={isVisible}>
      <FilterListComponent
        searchBy={""}
        searchText={""}
        whereClause={this.updateWhereClause.bind(this)}
        handleResultsClick={this.handleResultsClick.bind(this)}
        updateResultsOnFilterUpdate={this.updateResultsOnFilterUpdate.bind(this)}/>
      </div>
    )
  }
  updateWhereClause(whereClause) {
    this.setState({whereClause : whereClause})
  }
  handleResultsClick(whereClause) {
    this.tabChanged("results")
  }
  updateResultsOnFilterUpdate(whereClause) {
    //this.tabChanged("results")
    this.setState({whereClause : whereClause})
    //this.performEsriQuery(whereClause, false, true);
  }
  updateFilterOnResultUpdate(whereClause) {
    this.tabChanged("search")
  }

  renderResults() {
    if(this.state.tabSelected==="results") {
      return (
        <ResultsComponent results={this.resultsStore.getResults()}
                          updateFilterOnResultUpdate={this.updateFilterOnResultUpdate.bind(this)}
                          whereClause={this.state.whereClause}/>
      )
    } else {
      return "";
    }

  }
  render() {

    const searchComponent = this.renderFilters();
    const resultsComponent = this.renderResults();
    return (
      <div>
        {searchComponent}
        {resultsComponent}
      </div>
    )
  }
}
